var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6528 0.0266561C10.5531 -0.00888537 10.4469 -0.00888537 10.3472 0.0266561L0.38647 3.57623C-0.128824 3.75985 -0.128823 4.64015 0.386471 4.82377L2.1 5.4344V9.05121C1.79414 9.17476 1.575 9.50813 1.575 9.9V14.4545C1.575 14.7558 1.78868 15 2.05227 15H2.67273C2.93632 15 3.15 14.7558 3.15 14.4545V9.9C3.15 9.50813 2.93086 9.17476 2.625 9.05121V5.62149L10.3472 8.37334C10.4469 8.40889 10.5531 8.40889 10.6528 8.37334L20.6135 4.82377C21.1288 4.64015 21.1288 3.75985 20.6135 3.57623L10.6528 0.0266561ZM4.725 8.35977C4.725 7.95534 5.06797 7.66674 5.40588 7.78683L10.3472 9.54282C10.4469 9.57826 10.5531 9.57826 10.6528 9.54282L15.5941 7.78683C15.932 7.66674 16.275 7.95534 16.275 8.35977V11.3644C16.275 12.3558 13.6894 13.1594 10.5 13.1594C7.31056 13.1594 4.725 12.3558 4.725 11.3644V8.35977Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy);
export default __webpack_public_path__ + "static/media/Academy.acc117ebf28c8a3b42205403788f3296.svg";
export { ForwardRef as ReactComponent };